<template>
  <button :class="{'glass-designer-toolbar-button': true, 'gd-toolbar-button-leftbar': isLeftBar, 'active' : active && !disabled}" @click.prevent="onClicked" :disabled="disabled">
    <div><i :class="['far', icon]"></i></div>
    <span class="toolbar-button-label" v-if="label">{{label}}</span>
  </button>
</template>

<style lang="scss" scoped>

.glass-designer-toolbar-button {
  display: block;
  background-color: transparent;
  width: $editor-toolbar-button-size;
  height: $editor-toolbar-button-size;
  border: none;
  color: #d3d3d3;
  cursor: pointer;
  clear: both;
  margin: 2px 0px 8px 0px;
  padding: 0;
}
.glass-designer-toolbar-button:disabled {
  color: #707070;
  cursor: auto;
}

.glass-designer-toolbar-button.gd-toolbar-button-leftbar {
  margin: 2px 8px 2px 0px;
}
.glass-designer-toolbar-button.active {
  color: #5891c2;
  border-left: none;
  border-right: 3px solid #5891c2;
}
.glass-designer-toolbar-button.gd-toolbar-button-leftbar.active {
  border-right: none;
  border-left: 3px solid #5891c2;
}
.glass-designer-toolbar-button:hover:not(:disabled) {
  color: #53a3e9;
}
.glass-designer-toolbar-button i {
  font-size: 22px;
}
.toolbar-button-label {
  clear: both;
  font-size: 10px;
}
</style>

<script>
export default {
  name: 'ToolbarButton',
  props: {
    icon: String,
    active: Boolean,
    label: String,
    isLeftBar: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClicked(evt) {
      this.$emit('click', evt)
    }
  }
}
</script>